import ListStore from '@/store/core/ListStore';
import { action, computed } from 'mobx';
import services from '@/api/services';
import moment from 'moment/moment';

interface TaxpayerHistory {
  period?: string;
  totalIncome?: number;
  totalTax?: number;
  taxes?: {
    accountType: 'SC' | 'MPC' | 'CCSHI' | 'IIT';
    tax: number;
  }[];
}

export default class TaxpayerStatisticsStore extends ListStore<
  TaxpayerHistory[]
> {
  @computed get processedData(): any | undefined {
    if (!this.data) return;
    const items = this.data.map((item) => {
      const SC = item.taxes?.find((tax) => tax.accountType === 'SC')?.tax || 0;
      const MPC =
        item.taxes?.find((tax) => tax.accountType === 'MPC')?.tax || 0;
      const CCSHI =
        item.taxes?.find((tax) => tax.accountType === 'CCSHI')?.tax || 0;
      const IIT =
        item.taxes?.find((tax) => tax.accountType === 'IIT')?.tax || 0;
      return {
        ...item,
        isSummary: false,
        periodFormatted: moment(item.period).locale('ru').format('MMMM YYYY'),
        totalIncome: item.totalIncome?.toLocaleString('ru-RU'),
        totalTax: item.totalTax?.toLocaleString('ru-RU'),
        SC: SC.toLocaleString('ru-RU'),
        SC_raw: SC,
        MPC: MPC.toLocaleString('ru-RU'),
        MPC_raw: MPC,
        CCSHI: CCSHI.toLocaleString('ru-RU'),
        CCSHI_raw: CCSHI,
        IIT: IIT.toLocaleString('ru-RU'),
        IIT_raw: IIT,
      };
    });
    items.unshift({
      period: '',
      periodFormatted: 'ИТОГО',
      isSummary: true,
      totalIncome: this.data
        .reduce((acc, cur) => acc + (cur.totalIncome || 0), 0)
        .toLocaleString('ru-RU'),
      totalTax: this.data
        .reduce((acc, cur) => acc + (cur.totalTax || 0), 0)
        .toLocaleString('ru-RU'),
      SC: items
        .reduce((acc, cur) => acc + (cur.SC_raw || 0), 0)
        .toLocaleString('ru-RU'),
      SC_raw: 0,
      MPC: items
        .reduce((acc, cur) => acc + (cur.MPC_raw || 0), 0)
        .toLocaleString('ru-RU'),
      MPC_raw: 0,
      CCSHI_raw: 0,
      CCSHI: items
        .reduce((acc, cur) => acc + (cur.CCSHI_raw || 0), 0)
        .toLocaleString('ru-RU'),
      IIT_raw: 0,
      IIT: items
        .reduce((acc, cur) => acc + (cur.IIT_raw || 0), 0)
        .toLocaleString('ru-RU'),
    });
    return {
      items,
    };
  }

  @action.bound
  async fetch(id: string, year: string) {
    this.isFetching = true;
    try {
      const { data } = await services.platforms.getTaxHistory(id, {
        year,
      });
      this.data = data;
    } catch (e) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
